import React, { useState } from 'react';
import Button from "react-bootstrap/es/Button";
import {
    Alert, Checkbox, Form, FormControl, Glyphicon, Panel
} from "react-bootstrap";
import InstructionsAlert from "../components/InstructionsAlert";
import MultiSelect from "../components/multiselect/MultiSelect";
import DiseaseAutoComplete from "../components/multiselect/DiseaseAutoComplete";
import DiseaseRequiredModal from "../components/modals/DiseaseRequiredModal";
import {setDisease, toggleDisease, addDiseaseName, removeDiseaseName, setDiseaseNames} from "../redux/actions/diseaseActions";
import {useDispatch, useSelector} from "react-redux";
import {getCheckboxDBVal, transformEntitiesIntoAfpString} from "../AFPValues";
import {saveWidgetData, saveWidgetDataSilently} from "../redux/actions/widgetActions";
import {WIDGET} from "../constants";
import SaveButton from "../components/SaveButton";

const Disease = () => {
    const dispatch = useDispatch();
    const [showDiseaseRequiredModal, setShowDiseaseRequiredModal] = useState(false);
    const disease = useSelector((state) => state.disease.disease);
    const diseaseNames = useSelector((state) => state.disease.diseaseNames);
    const addedDiseaseNames = useSelector((state) => state.disease.addedDiseaseNames);
    const savedDiseaseNames = useSelector((state) => state.disease.savedDiseaseNames);
    const isSavedToDB = useSelector((state) => state.disease.isSavedToDB);
    const paperPassword = useSelector((state) => state.paper.paperData.paperPasswd);
    const person = useSelector((state) => state.person.person);

    return (
        <div>
            <InstructionsAlert
                alertTitleNotSaved=""
                alertTitleSaved="Well done!"
                alertTextNotSaved="If this paper reports a disease model, please choose one or more that it describes."
                alertTextSaved="The data for this page has been saved, you can modify it any time."
                saved={isSavedToDB}
            />
            <Panel>
                <Panel.Heading>
                    <Panel.Title componentClass="h3">Disease model data in the paper</Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                    <div className="container-fluid">
                        <Form>
                            <Checkbox checked={disease.checked} onClick={() => {
                                // When unchecking, clear disease names list
                                if (disease.checked) {
                                    dispatch(setDiseaseNames([]));
                                }
                                // toggleDisease already clears the details field
                                dispatch(toggleDisease());
                            }}>
                                <strong>The paper describes an experimental model for a specific human disease (e.g., Parkinson's disease) by employing at least one of the following:</strong>
                            </Checkbox>
                            <ul>
                                <li><strong>Gene/allele or strain that recapitulates disease phenotype(s) and provides insight into disease pathogenesis. Please provide official names for strains (e.g., CL2006).</strong></li>
                                <li><strong>Transgenic studies with human and/or worm disease relevant gene.</strong></li>
                                <li><strong>Modifiers of a new or previously established disease model (e.g., drugs, herbals, chemicals, etc).</strong></li>
                            </ul>
                        </Form>
                    </div>
                </Panel.Body>
            </Panel>
            
            {disease.checked && (
                <>
                    <Alert bsStyle="warning" style={{marginTop: '20px', marginBottom: '20px'}}>
                        <strong>Important:</strong> Since you indicated this paper describes a human disease model, 
                        please specify which disease(s) are studied in your paper. This information is required.
                    </Alert>
                    
                    <Panel>
                        <Panel.Heading>
                            <Panel.Title componentClass="h3">Specific diseases studied in the paper</Panel.Title>
                        </Panel.Heading>
                        <Panel.Body>
                            <MultiSelect
                                items={diseaseNames}
                                addedItems={addedDiseaseNames}
                                savedItems={savedDiseaseNames}
                                itemsNameSingular="disease"
                                itemsNamePlural="diseases"
                                addItemFunction={(disease) => dispatch(addDiseaseName(disease))}
                                remItemFunction={(disease) => dispatch(removeDiseaseName(disease))}
                                searchType="disease"
                                sampleQuery="e.g. Parkinson's"
                                defaultExactMatchOnly={false}
                                exactMatchTooltip="Check this to search for exact disease names only"
                                autocompletePlaceholder="Type disease names to search. For example:
Parkinson's disease
Alzheimer's disease
Cancer
Diabetes"
                                customAutoComplete={(props) => <DiseaseAutoComplete {...props} />}
                                customTitle="Diseases"
                                showTpcBadge={false}
                                emptyStateText="No diseases selected"
                            />
                        </Panel.Body>
                    </Panel>
                </>
            )}

            {disease.checked && (
                <Panel>
                    <Panel.Heading>
                        <Panel.Title componentClass="h3">
                            Additional comments on disease models in the paper
                        </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>
                        <div className="container-fluid">
                            <div style={{marginBottom: '10px'}}>
                                Write comments here
                            </div>
                            <FormControl componentClass="textarea" multiple
                                         value={disease.details === "checked" ? "" : disease.details}
                                         onClick={() => dispatch(setDisease(true, disease.details === "checked" ? "" : disease.details))}
                                         onChange={(event) => {
                                             dispatch(setDisease(true, event.target.value));
                                         }}
                            />
                        </div>
                    </Panel.Body>
                </Panel>
            )}
            <div align="right">
                <SaveButton
                    payload={{
                        disease: getCheckboxDBVal(disease.checked, (disease.details === "checked") ? "" : disease.details),
                        disease_list: diseaseNames,
                        person_id: "two" + person.personId,
                        passwd: paperPassword
                    }}
                    widgetName={WIDGET.DISEASE}
                    buttonText="Save and go to next section"
                    onBeforeSave={() => {
                        // Validate that if disease is checked, at least one disease name is selected
                        if (disease.checked && diseaseNames.length === 0) {
                            setShowDiseaseRequiredModal(true);
                            return false;
                        }
                        return true;
                    }}
                />
            </div>
            
            <DiseaseRequiredModal 
                show={showDiseaseRequiredModal} 
                close={() => setShowDiseaseRequiredModal(false)}
            />
        </div>
    );
}

export default Disease;